import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ProductType } from '../../interfaces/total-reports/product-type.interface';

@Injectable({
    providedIn: 'root',
})
export class ProductService {
    constructor(private readonly http: HttpClient) {}

    getProducts(): Observable<ProductType[]> {
        return this.http.get<ProductType[]>(environment.url + `/api/Products`);
    }

    getProductsAll(): Observable<any> {
        return this.http.get<any>(
            environment.url + `/api/Products?page=1&pageSize=100000`,
        );
    }
}
